var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _c("div", { staticClass: "layout__title" }, [
          _c("h3", [_vm._v("Proyecto " + _vm._s(_vm.form.nombre))]),
          _vm._v(" "),
          _c("label", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado == "N",
                    expression: "form.estado == 'N'"
                  }
                ],
                staticClass: "noti-secondary"
              },
              [_vm._v("Estado: "), _c("strong", [_vm._v("NUEVO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado == "A",
                    expression: "form.estado == 'A'"
                  }
                ],
                staticClass: "noti-success"
              },
              [_vm._v("Estado: "), _c("strong", [_vm._v("PENDIENTE")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado == "I",
                    expression: "form.estado == 'I'"
                  }
                ],
                staticClass: "noti-danger"
              },
              [_vm._v("Estado: "), _c("strong", [_vm._v("ANULADO")])]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.estado == "FF",
                    expression: "form.estado == 'FF'"
                  }
                ],
                staticClass: "noti-primary"
              },
              [_vm._v("Estado: "), _c("strong", [_vm._v("FINALIZADO")])]
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _vm.consultar
            ? _c(
                "button",
                {
                  staticClass: "btn-info btn--bigger",
                  on: {
                    click: function($event) {
                      return _vm.botonBuscar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-search" }),
                  _vm._v(" "),
                  _c("span", [_vm._v("Buscar")])
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "layout__main" }, [
        _c("div", { staticClass: "layout__main-form" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c(
                    "div",
                    { staticClass: "form-field" },
                    [
                      _c(
                        "input-field",
                        {
                          attrs: {
                            disabled: _vm.disabledInput,
                            id: "codigo",
                            placeholder: "Escriba un código..."
                          },
                          model: {
                            value: _vm.form.codigo,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "codigo", $$v)
                            },
                            expression: "form.codigo"
                          }
                        },
                        [
                          _c("span", [_vm._v("Código*")]),
                          _vm._v(" "),
                          _vm.errores.codigo
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.errores.codigo[0]) +
                                      "\n                  "
                                  )
                                ]
                              )
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c("div", { staticClass: "form-field select2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c(
                        "div",
                        { staticClass: "select2-field" },
                        [
                          _c("v-select", {
                            attrs: {
                              disabled: _vm.disabledInput,
                              tooltip: _vm.selectedPersona
                                ? _vm.selectedPersona.nombre
                                : null,
                              placeholder: "Busque y seleccione...",
                              id: "persona",
                              options: _vm.optionPersonas,
                              label: "nombre"
                            },
                            on: {
                              input: _vm.inputPersona,
                              search: _vm.onSearchPersona
                            },
                            model: {
                              value: _vm.selectedPersona,
                              callback: function($$v) {
                                _vm.selectedPersona = $$v
                              },
                              expression: "selectedPersona"
                            }
                          }),
                          _vm._v(" "),
                          _c("label", { attrs: { for: "persona" } }, [
                            _vm._v("Cliente*")
                          ]),
                          _vm._v(" "),
                          _vm.errores.persona_id
                            ? _c(
                                "span",
                                {
                                  staticClass: "helper-text text-danger",
                                  attrs: { slot: "helper" },
                                  slot: "helper"
                                },
                                [
                                  _vm._v(
                                    "\n                      " +
                                      _vm._s(_vm.errores.persona_id[0]) +
                                      "\n                    "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-info",
                          attrs: {
                            disabled: _vm.disabledInput,
                            type: "button"
                          },
                          on: {
                            click: function($event) {
                              return _vm.buscarPersona()
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-search" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-md-6" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          disabled: _vm.disabledInput,
                          id: "nombre",
                          placeholder: "Escriba un nombre..."
                        },
                        model: {
                          value: _vm.form.nombre,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "nombre", $$v)
                          },
                          expression: "form.nombre"
                        }
                      },
                      [
                        _c("span", [_vm._v("Nombre*")]),
                        _vm._v(" "),
                        _vm.errores.nombre
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.errores.nombre[0]) +
                                    "\n                "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-xs-12 col-md-6" },
                  [
                    _c(
                      "input-field",
                      {
                        attrs: {
                          disabled: _vm.disabledInput,
                          id: "descripcion",
                          placeholder: "Escriba una descripción..."
                        },
                        model: {
                          value: _vm.form.descripcion,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "descripcion", $$v)
                          },
                          expression: "form.descripcion"
                        }
                      },
                      [
                        _c("span", [_vm._v("Descripción*")]),
                        _vm._v(" "),
                        _vm.errores.descripcion
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.errores.descripcion[0]) +
                                    "\n                "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col-xs-12 col-md-6" }, [
                  _c("div", { staticClass: "form-field" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "datepicker-field datepicker-field--stretch"
                      },
                      [
                        _c("VueCtkDateTimePicker", {
                          attrs: {
                            disabled: _vm.disabledInput,
                            id: "fecha_inicio",
                            locale: "es",
                            "only-datetime": "",
                            "no-label": "",
                            "button-now-translation": "Ahora",
                            format: "YYYY-MM-DD HH:mm",
                            formatted: "YYYY-MM-DD HH:mm",
                            label: "Seleccione fecha..."
                          },
                          model: {
                            value: _vm.form.fecha_inicio,
                            callback: function($$v) {
                              _vm.$set(_vm.form, "fecha_inicio", $$v)
                            },
                            expression: "form.fecha_inicio"
                          }
                        }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Fecha inicio*")]),
                        _vm._v(" "),
                        _vm.errores.fecha_inicio
                          ? _c(
                              "span",
                              {
                                staticClass: "helper-text text-danger",
                                attrs: { slot: "helper" },
                                slot: "helper"
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.errores.fecha_inicio[0]) +
                                    "\n                  "
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "layout__main-buttons" }, [
          _c("div", { staticClass: "card" }, [
            _c("div", { staticClass: "card__content" }, [
              _vm.crear && _vm.editar
                ? _c(
                    "button",
                    {
                      staticClass: "btn-success",
                      attrs: { disabled: _vm.disabledInput, type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.botonGuardar()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-save" }),
                      _c("span", [_vm._v("Guardar")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn-light btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.botonLimpiar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-plus" }),
                  _c("span", [_vm._v("Nueva")])
                ]
              ),
              _vm._v(" "),
              _vm.eliminar
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.tieneId &&
                            _vm.form.estado != "N" &&
                              _vm.form.estado != "I" &&
                              _vm.form.estado != "FF",
                          expression:
                            "tieneId && (form.estado != 'N' && form.estado != 'I' && form.estado != 'FF')"
                        }
                      ],
                      staticClass: "btn-danger btn--text",
                      attrs: { type: "button" },
                      on: {
                        click: function($event) {
                          return _vm.botonAnular()
                        }
                      }
                    },
                    [
                      _c("i", { staticClass: "fa fa-ban" }),
                      _c("span", [_vm._v("Eliminar")])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tieneId && _vm.form.estado == "I",
                      expression: "tieneId && form.estado == 'I'"
                    }
                  ],
                  staticClass: "btn-success btn--text",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.botonReactivar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-power-off" }),
                  _c("span", [_vm._v("Re-activar")])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.tieneId && _vm.form.estado != "FF",
                      expression: "tieneId && form.estado != 'FF'"
                    }
                  ],
                  staticClass: "btn-primary",
                  attrs: { type: "button" },
                  on: {
                    click: function($event) {
                      return _vm.botonFinalizar()
                    }
                  }
                },
                [
                  _c("i", { staticClass: "fa fa-flag-checkered" }),
                  _c("span", [_vm._v("Finalizar")])
                ]
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "55%",
            height: "auto",
            name: "listaPersonas",
            scrollable: ""
          }
        },
        [
          _c("lista-personas", {
            attrs: { tipoFiltro: "C", filterStatus: false },
            on: { selected: _vm.seleccionarPersona }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            width: "80%",
            height: "auto",
            scrollable: true,
            name: "modalListaProyectos"
          }
        },
        [
          _c("listaProyectos", {
            attrs: { enabledExcel: "" },
            on: { selected: _vm.seleccionarProyecto }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e835104", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e835104","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/Proyectos.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-9e835104","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/procesos/Proyectos.vue
// module chunks = 0